import { FilterDescriptor, SortDescriptor } from "@nstep-common/core";

export class ExportDataRequest {
	reportName: string = '';
	columns: string[] = [];
	sortList: SortDescriptor[] = [];
	filterList: FilterDescriptor[] = [];
	exportPage: ExportPage | null = null;

	constructor(data: Partial<ExportDataRequest> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

export class ExportPage {
	page: number = 1;
	itemsPerPage: number = 15;

	constructor(data: Partial<ExportPage> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}